import { render } from "./catGrooming.vue?vue&type=template&id=0d85f3a6"
import script from "./catGrooming.vue?vue&type=script&lang=js"
export * from "./catGrooming.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__